import DateFormat from '@/Enums/Format/DateFormat.enum';
import moment from 'moment';

export const getDefaultDateRangeFormatted = (
  length: number,
  format: DateFormat = DateFormat.Iso8601,
): { dateRangeStart: string; dateRangeEnd: string } => {
  const safeLength = Math.max(1, length);
  const end = moment();
  return {
    dateRangeEnd: end.format(format),
    dateRangeStart: end
      .clone()
      .subtract({ days: safeLength - 1 })
      .format(format),
  };
};
